import React, { useEffect, useRef, useState } from "react";
import "./PracticeModeProgressBar.css";
import images from "../../../../../utilities/images/images";
import { useSelector } from "react-redux";





const PracticeModeProgressBar = ({ totalQuestions, streak }) => {
  const progress = Array.isArray(streak?.progress) ? streak.progress : [];
  const maxStreak = streak?.maxStreak;
  const message = streak?.progressive_message;

  const lastActionType = useSelector(
    (state) => state.examSlice.lastActionType
  );



  const prevQidRef = useRef(null);

  const currentQid = useSelector(
    (state) => state.examSlice.questionsData[state.examSlice.currentQuestionIndex]?.qid
  );



  const [showMessage, setShowMessage] = useState(null);

  // Show message for 2 seconds
  useEffect(() => {

    // 🚫 If Save & Next was clicked, never show message
    if (lastActionType === "SAVE_NEXT") {
      setShowMessage(null);
      return;
    }

    // ✅ Show message only for option click
    if (streak?.progressive_message) {
      setShowMessage(streak.progressive_message);

      const timer = setTimeout(() => {
        setShowMessage(null);
      }, 2000);

      return () => clearTimeout(timer);
    }

  }, [streak?.progressive_message, lastActionType]);
  // useEffect(() => {
  //   setShowMessage(null);
  // }, [streak?.progress]);

  return (
    <div className="practice-progress-container">
      {/* Header */}
      <div className="practice-progress-header">
        <span className="practice-progress-title">Your Streak</span>
        <span className="practice-progress-count">
          {maxStreak?.count || 0} in a Row
          <img
            src={images.streakfire_icon}
            alt="fire"
            className="streak-fire-icon"
          />
        </span>
      </div>

      {/* Progress Bar */}
      <div className="practice-progress-bar">
        {Array.from({ length: totalQuestions }).map((_, index) => {
          let status = "empty";

          if (index < progress.length) {
            status = progress[index] ? "correct" : "wrong";
          }

          return (
            <span
              key={index}
              className={`practice-progress-segment ${status}`}
            />
          );
        })}
      </div>

      {/* Message (visible only 2 seconds) */}
      {showMessage && lastActionType === "OPTION_CLICK" && (
        <div
          className="practice-progress-message"
          style={{ backgroundColor: showMessage.bg_colour }}
        >
          <span className="emoji">{showMessage.emoji}</span>
          <span className="text">{showMessage.text}</span>
        </div>
      )}
    </div>
  );
};

export default PracticeModeProgressBar;